/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointClickBIcon16Solid = forwardRef('HandPointClickBIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5.125A4.375 4.375 0 0 0 3.125 4.5a.875.875 0 1 0 1.75 0 2.625 2.625 0 0 1 5.25 0 .875.875 0 0 0 1.75 0A4.375 4.375 0 0 0 7.5.125Z" }),
        React.createElement("path", { d: "M7.612 16.002h4.13a1.65 1.65 0 0 0 1.591-1.214l.965-3.518a2.25 2.25 0 0 0-1.755-2.807L9 7.8V4.5a1.5 1.5 0 0 0-3 0v5.631l-1.516-.908a1.644 1.644 0 0 0-1.97 2.61l3.97 3.722c.305.287.709.447 1.128.447Z" })));
});
